import { useContext } from 'react';
import Cookies from 'universal-cookie';

import { CookiesContext } from '../contexts/Cookies';

const useCookiesContext = (): Cookies => useContext(CookiesContext);

export default useCookiesContext;
